import { useCallback } from 'react';
import * as Sentry from '@sentry/nextjs';
import { CaptureContext } from '@sentry/types';
import merge from 'lodash/merge';

import { useInnskraningStore } from '../../stores/onboarding/useInnskraningStore';

type InjectedContextCallback = (sentry: typeof Sentry) => CaptureContext;

export const useInnskraningSentryLogging = () => {
  const user = useInnskraningStore(useCallback((state) => state.user, []));
  const mailinglist = useInnskraningStore(useCallback((state) => state.mailinglist, []));
  const properties = useInnskraningStore(
    useCallback((state) => state.selectedProperties, [])
  );

  const getDefaultCaptureContext = (injectedContext?: CaptureContext): CaptureContext =>
    merge(
      {
        level: 'error',
        contexts: {
          data: {
            user,
            mailinglist,
            properties,
          },
        },
        tags: {
          environment: process.env.NODE_ENV,
        },
      } as CaptureContext,
      injectedContext
    );

  const captureException = (
    error: unknown,
    injectedContext?: InjectedContextCallback
  ) => {
    window.Sentry?.captureException(error);
  };

  const captureMessage = (message: string, injectedContext?: InjectedContextCallback) => {
    window.Sentry?.captureMessage(message);
  };

  return {
    captureException,
    captureMessage,
  };
};
